import React, { useContext, useEffect, useState } from "react";
import Form from "../../../components/form";
import cfe from "../../../services/cfe";
import ActionTable from "../../../components/table/ActionTable";
import { CircularProgress } from "@mui/material";
import { mergeParams } from "../../../helpers/helpers";
import AppContext from "../../../container/context";

export default function Lista({ history, location }) {
  const [dados, setDados] = useState(
    mergeParams(
      {
        nome: "",
        email: "",
        instituicaoId: 0,
      },
      location
    )
  );
  const [clientes, setClientes] = useState([]);
  const [instituicoes, setInstituicoes] = useState([]);
  const [carregando, setCarregando] = useState(false);
  const { notification } = useContext(AppContext);

  useEffect(() => {
    if (dados.nome || dados.email || dados.instituicaoId) {
      carregarClientes();
    }
    carregarInstituicoes();
  }, []);

  const carregarClientes = (filtrosEnviar = dados) => {
    if (
      filtrosEnviar.nome === "" &&
      filtrosEnviar.email === "" &&
      filtrosEnviar.instituicaoId === ""
    )
      return notification("warning", "Preencha ao menos um filtro.");

    setDados(filtrosEnviar);
    setCarregando(true);

    cfe
      .get("admin/clientes/listar", filtrosEnviar)
      .then((res) => {
        console.log("res", res);
        setClientes(res);
        setCarregando(false);
      })
      .catch((e) => {
        notification("error", "Erro ao listar os usuários");
        setCarregando(false);
      });
  };

  const carregarInstituicoes = () => {
    cfe
      .get("admin/instituicoes/listar")
      .then((res) => {
        setInstituicoes(res);
      })
      .catch((e) => notification("error", "Erro ao listar os instituições"));
  };

  const fFiltros = {
    title: "Filtros",
    form: {
      nome: {
        label: "Nome",
        type: "text",
        space: 4,
        value: dados.nome,
      },
      email: {
        type: "text",
        label: "Email",
        space: 4,
        value: dados.email,
      },
      instituicaoId: {
        label: "Instituição",
        space: 4,
        value: dados.instituicaoId,
        type: "select",
        emptyItem: true,
        array: {
          data: instituicoes,
          value: "id",
          desc: "nomeFantasia",
        },
      },
    },

    submit: {
      label: "Buscar",
      action: carregarClientes,
    },

    urlParams: true,
    history,
    location,
  };

  const tRegistros = {
    title: "Usuários",
    newItemAction: () => history.push("/app/cfe-clientes/inserir"),
    onLineClick: (id) => history.push(`/app/cfe-clientes/editar/${id.id}`),
    columns: [
      {
        label: "Nome",
        name: "nome",
      },
      {
        label: "Email",
        name: "email",
      },
    ],
    array: clientes,
  };

  return (
    <div>
      <Form formData={fFiltros} />
      {carregando ? (
        <CircularProgress />
      ) : (
        <ActionTable structure={tRegistros} />
      )}
    </div>
  );
}
